import { createContext, useContext } from 'react'

import { SessionStatus, UseTransmitReactHook } from '@ally/transmitigator'

// Provides a subset of ScreenPayload. All states involving screens map to 'Authenticating'

export type SessionContextValues = UseTransmitReactHook['actions'] & {
  sessionStatus: SessionStatus
  isAuthenticated: boolean
}

export const SessionContext = createContext<SessionContextValues>(
  {} as SessionContextValues,
)

export const useSession = (): SessionContextValues => {
  return useContext(SessionContext)
}
